export default function serifTransform(input) {
  return input
    .replace(/A/gi, "α")
    .replace(/B/gi, "ɓ")
    .replace(/C/gi, "૮")
    .replace(/D/gi, "∂")
    .replace(/E/gi, "ε")
    .replace(/F/gi, "ƒ")
    .replace(/G/gi, "ɠ")
    .replace(/H/gi, "ɦ")
    .replace(/I/gi, "เ")
    .replace(/J/gi, "ʝ")
    .replace(/K/gi, "ҡ")
    .replace(/L/gi, "ℓ")
    .replace(/M/gi, "ɱ")
    .replace(/N/gi, "ɳ")
    .replace(/O/gi, "σ")
    .replace(/P/gi, "ρ")
    .replace(/Q/gi, "φ")
    .replace(/R/gi, "૨")
    .replace(/S/gi, "ร")
    .replace(/T/gi, "ƭ")
    .replace(/U/gi, "µ")
    .replace(/V/gi, "ѵ")
    .replace(/W/gi, "ω")
    .replace(/X/gi, "א")
    .replace(/Y/gi, "ყ")
    .replace(/Z/gi, "ƶ")
    .replace(/ /gi, "ㅤ");
}
